<template>
  <layout titlePage=" " :route="{ name: 'carteira' }">
    <section class="c-successful-message">
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column">
          <div class="c-receipt__wrapper has-text-centered">
            <div class="c-successful-message__content">
              <img
                class="c-successful-message__content--img"
                :src="!error ? copied : errorCopied"
              />
              <p
                class="c-successful-message__content--title"
                :class="{ error__title: this.error }"
              >
                {{ message }}
              </p>

              <p class="c-successful-message__content--subtitle">
                {{ subtitle }}
              </p>
              <p v-if="showButton">
                <button
                  v-clipboard:copy="code"
                  v-clipboard:success="copiedSuccess"
                  type="button"
                  class="button is-big is-support"
                >
                  Copiar código de pagamento PIX
                </button>
              </p>
              <p v-if="!error">Você já pode fechar essa guia ;)</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'

import copied from '@/assets/img/copied.png'
import errorCopied from '@/assets/img/error-copied.png'

export default {
  components: {
    layout,
  },

  data() {
    return {
      copied,
      errorCopied,
      code: '',
      showButton: false,
      message: 'Código copiado com sucesso!',
      subtitle:
        'Agora é só acessar a opção "PIX" no seu Internet Banking ou aplicativo de pagamentos e prosseguir com o pagamento do seu presente.',
      error: false,
    }
  },

  created() {
    const brCode = new URLSearchParams(window.location.search)
    this.code = brCode.get('brCode')
  },

  async mounted() {
    const regexInvoice =
      /00020101021226790014br.gov.bcb.pix2557invoice.starkbank.com\/v2\/[a-z0-9.]+5204000053039865802BR5925Casar.Com Site De Casamen6009Sao Paulo62070503[*a-zA-Z0-9.]+/g
    const regexBrCode =
      /00020101021226790014br.gov.bcb.pix2557brcode.starkinfra.com\/v2\/[a-z0-9.]+5204000053039865802BR5925Casar.Com Site De Casamen6009Sao Paulo62070503[*a-zA-Z0-9.]+/g

    if (regexInvoice.test(this.code) || regexBrCode.test(this.code)) {
      const textCopied = await navigator.clipboard.writeText(this.code).then(
        function () {
          return true
        },
        function () {
          return false
        }
      )

      if (!textCopied) {
        this.message = 'Não foi possível copiar o código “Copia e Cola”'
        this.subtitle = 'Tente novamente clicando no botão abaixo.'
        this.error = this.showButton = true
      }
    } else {
      this.message = 'O código “Copia e Cola” está inválido'
      this.subtitle =
        'Por favor, abra novamente o e-mail que recebeu e clique em “Copiar código de pagamento PIX”.'
      this.error = true
    }
  },
  methods: {
    copiedSuccess() {
      this.message = 'Código copiado com sucesso!'
      this.subtitle =
        'Agora é só acessar a opção "PIX" no seu Internet Banking ou aplicativo de pagamentos e prosseguir com o pagamento do seu presente.'
      this.error = false
      this.showButton = false
    },
  },
}
</script>

<style lang="scss">
.c-successful-message {
  &__content {
    &--img {
      padding-bottom: 25px;
    }

    &--title {
      font-size: 21px;
      font-weight: bold;
      color: #3dafb0;
      padding-bottom: 30px;
    }

    &--subtitle {
      padding-bottom: 30px;
    }
  }
}

.error {
  &__title {
    font-size: 19px;
    color: $error;
  }
}
</style>
